import i18n from '../../i18n'
import requiredRules from './requiredRules'

const noSpaceRules = (v) => [
  ...requiredRules(v),
  !/\s/.test(v) || i18n.t('warnings.validation.no_space')
]

export default noSpaceRules
